<template>
    <div class="sa-list-component" style="padding-bottom: 20px">
        <div class="sa-list-component-header">
            <div class="sa-page-search-component">
                <b-form style="width: 100%" @submit.prevent="onSubmit">
                    <b-row class="sa-form-btn-filter">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                            <label class="sa-label-data">Cognome</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <input class="sa-page-search-component-input" v-model="filtroRiepilogoOperatori.cognome" placeholder="Inserisci un cognome.." />
                                <button class="sa-page-search-component-btn-search" title="Cognome">
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                            <label class="sa-label-data">Nome</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <input class="sa-page-search-component-input" v-model="filtroRiepilogoOperatori.nome" placeholder="Inserisci un nome.." />
                                <button class="sa-page-search-component-btn-search" title="Nome">
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                            <label class="sa-label-data">Ruolo</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <input class="sa-page-search-component-input" v-model="filtroRiepilogoOperatori.tipo" placeholder="Inserisci un ruolo.." />
                                <button class="sa-page-search-component-btn-search" title="Ruolo">
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(nominativo)="{ item }">
                        <span>
                            <b> {{ item.cognome }} {{ item.nome }} </b>
                        </span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button size="sm" v-b-tooltip.hover title="Info Equipe" variant="outline-secondary" @click="onClickVisualizzaEquipe(row)" class="mr-2">
                                <font-awesome-icon icon="info-circle"></font-awesome-icon>
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover title="Info Attivita" variant="outline-secondary" @click="onClickVisualizzaAttivita(row)">
                                <font-awesome-icon icon="book-open"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <!--<b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>-->
            </b-row>
        </div>
        <rsa-paziente-riepilogo-operatori-equipe-list-modal-component ref="mdlRsaPazienteRiepilogoOperatoriEquipeListModalComponent"> </rsa-paziente-riepilogo-operatori-equipe-list-modal-component>
        <rsa-paziente-riepilogo-operatori-attivita-list-modal-component ref="mdlRsaPazienteRiepilogoOperatoriAttivitaListModalComponent"> </rsa-paziente-riepilogo-operatori-attivita-list-modal-component>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazienteRiepilogoOperatoriEquipeListModalComponent from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue";
import RsaPazienteRiepilogoOperatoriAttivitaListModalComponent from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue";
export default {
    components: { RsaPazienteRiepilogoOperatoriEquipeListModalComponent, RsaPazienteRiepilogoOperatoriAttivitaListModalComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            items: [],
            visibleFields: [],
            perPage: 50,
            currentPage: 1,
            page: 1,
            listKey: 0,
            rows: 0,
            itemsEquipe: [],
            itemsAttivita: [],
            fields: [
                {
                    label: "Cognome/Nome",
                    key: "nominativo",
                    sortable: false,
                },
                {
                    label: "Ruolo",
                    key: "tipo",
                    sortable: false,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", visible: true },
            ],
            fieldsEquipe: [
                { label: "Equipe", key: "equipe" },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                },
                {
                    label: "Data Fine",
                    key: "dataFine",
                },
            ],
            fieldsAttivita: [
                { label: "Indicazioni", key: "indicazioni" },

                { label: "Note", key: "note" },

                {
                    label: "Data/Ora Effettuata",
                    key: "dataOraEffettuata",
                },
            ],
            pathResourceEquipeDettaglio: "/rsaequipedettaglio",
            pathResourceAttivita: "/rsaattivitapazienti",
            pathResourceUtenti: "/users",
            tipoDetails: null,
            filtroRiepilogoOperatori: {
                nome: null,
                cognome: null,
                tipo: null,
                username: null,
            },
        };
    },
    mounted() {
        let me = this;
        if (sessionStorage["filtroRiepilogoOperatori"]) {
            me.filtroRiepilogoOperatori = JSON.parse(sessionStorage["filtroRiepilogoOperatori"]);
        }
    },
    watch: {
        currentPage() {
            let me = this;
            me.page = me.currentPage;
            this.loadData();
        },
    },
    methods: {
        init() {
            this.visibleFields = this.fields;
            this.loadData();
        },
        loadData() {
            let me = this;
            me.filtroRiepilogoOperatori.page = me.currentPage;
            me.filtroRiepilogoOperatori.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResourceEquipeDettaglio + "/riepilogo", me.filtroRiepilogoOperatori, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.list.length;
            me.$emit("afterLoadData", me.items);
        },
        loadDataError(response) {
            console.log("errore response", response);
        },
        onClickVisualizzaEquipe(row) {
            let me = this;
            me.$refs.mdlRsaPazienteRiepilogoOperatoriEquipeListModalComponent.init(row);
        },
        onClickVisualizzaAttivita(row) {
            let me = this;
            me.$refs.mdlRsaPazienteRiepilogoOperatoriAttivitaListModalComponent.init(row);
        },
        onSubmit() {
            let me = this;
            me.$emit("onBeforeLoadData", true);
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoOperatori"] = JSON.stringify(me.filtroRiepilogoOperatori);
            this.loadData();
        },
    },
};
</script>
